module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/slipper-49d4dc376bf42014545be3466e7e8811.svg";